import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import posed, { PoseGroup } from 'react-pose';
import classNames from 'classnames';
import css from './NetworkGrid.css';
import * as networkImages from '../../resources/png/networks';
import { determineIfActiveSegments, NETWORK_GROUPS } from '../utils';

const AnimationItem = posed.div({
    enter: {
        opacity: 1,
        y: 0,
        delay: ({ i }) => {
            return i * 50;
        },
    },
    exit: { opacity: 0, y: 20 },
});

const NetworkGrid = ({ networks, translate, editStart, readOnly = false }) => {
    let cols = 0;
    return (
        <div className={css.networks}>
            {NETWORK_GROUPS.map(group => {
                const groupNetworks = networks.filter(network => network.group === group);
                return (
                    <PoseGroup key={`network_group_${group}`} animateOnMount>
                        {groupNetworks.map(network => {
                            const active = determineIfActiveSegments(network);
                            const hasLoginError = !!network?.distribution?.login_error_message;
                            const disabled = readOnly && !active;
                            return (
                                <AnimationItem key={network.name} i={cols++} className={css.networkContainer}>
                                    <div className={css.network}>
                                        <div
                                            role="button"
                                            className={classNames(css.networkInner, {
                                                [css.configured]: network.distribution,
                                                [css.disabledNetwork]: disabled,
                                            })}
                                            onClick={() => !disabled && editStart(network)}
                                            tabIndex={0}
                                        >
                                            <img alt={network.name} src={networkImages[network.name]} />
                                            {network.distribution && (
                                                <div className={css.activity}>
                                                    <div
                                                        className={`${css.activityDot} ${
                                                            hasLoginError ? css.error : active ? css.active : ''
                                                        }`}
                                                    />
                                                    <div className={css.activityLabel}>
                                                        {hasLoginError ? 'Login Error' : active ? 'Active' : 'Inactive'}
                                                    </div>
                                                </div>
                                            )}
                                            {!disabled && (
                                                <div className={css.networkConfigure}>
                                                    {translate(
                                                        `STATIC.PAGES.AUDIENCES.${
                                                            readOnly ? 'VIEW' : 'CONFIGURE'
                                                        }_NETWORK`
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </AnimationItem>
                            );
                        })}
                    </PoseGroup>
                );
            })}
        </div>
    );
};

NetworkGrid.propTypes = {
    networks: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            group: PropTypes.string,
            distribution: PropTypes.shape({
                login_error_message: PropTypes.string,
            }),
        })
    ).isRequired,
    editStart: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(NetworkGrid);
